import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 rounded-lg overflow-hidden">
              <img 
                src="/images/bee-icon.png" 
                alt="UrbanHive - Apiculture Urbaine" 
                className="w-full h-full object-contain"
              />
            </div>
            <span className="text-xl font-serif font-bold text-gray-900">UrbanHive</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-honey transition-colors font-medium">
              Accueil
            </Link>
            <Link to="/getting-started" className="text-gray-700 hover:text-honey transition-colors font-medium">
              Débuter
            </Link>
            <Link to="/equipment" className="text-gray-700 hover:text-honey transition-colors font-medium">
              Équipement
            </Link>
            <Link to="/legal" className="text-gray-700 hover:text-honey transition-colors font-medium">
              Réglementation
            </Link>
            <Link to="/lexique" className="text-gray-700 hover:text-honey transition-colors font-medium">
              Lexique
            </Link>
            <Link to="/blog" className="text-gray-700 hover:text-honey transition-colors font-medium">
              Blog
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <Link to="/" className="text-gray-700 hover:text-honey transition-colors font-medium">
                Accueil
              </Link>
              <Link to="/getting-started" className="text-gray-700 hover:text-honey transition-colors font-medium">
                Débuter
              </Link>
              <Link to="/equipment" className="text-gray-700 hover:text-honey transition-colors font-medium">
                Équipement
              </Link>
              <Link to="/legal" className="text-gray-700 hover:text-honey transition-colors font-medium">
                Réglementation
              </Link>
              <Link to="/lexique" className="text-gray-700 hover:text-honey transition-colors font-medium">
                Lexique
              </Link>
              <Link to="/blog" className="text-gray-700 hover:text-honey transition-colors font-medium">
                Blog
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
